<template>
  <button
    @click="$emit('toggle')"
    type="button"
    class="inline-flex items-center justify-center w-8 h-8 transition-colors duration-normal text-theme-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-main-lighter lg:hidden"
    :aria-label="isOpen ? $t('Close menu') : $t('Open menu')"
    :aria-expanded="isOpen"
  >
    <span class="sr-only">{{ isOpen ? $t('Close menu') : $t('Open menu') }}</span>
    <div class="relative flex items-center justify-center w-6 h-5">
      <div
        class="hamburger-icon"
        :class="{ 'hamburger-open': isOpen }"
      >
        <div class="hamburger-line bg-theme-primary dark:bg-secondary"></div>
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'MenuToggle',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle'],
};
</script>

<style scoped>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.hamburger-icon {
  position: relative;
  width: 14px;
  height: 20px;
  display: flex;
  align-items: center;
}

.hamburger-line {
  position: relative;
  width: 100%;
  height: 1px;
  border-radius: 2px;
  transition: all 0.3s ease-in-out;
}

/* Before pseudo-element (top line) */
.hamburger-line::before {
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  @apply bg-theme-primary dark:bg-secondary;
  border-radius: 2px;
  transform: translateY(-6px);
  transition: all 0.3s ease-in-out;
}

/* After pseudo-element (bottom line) */
.hamburger-line::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  @apply bg-theme-primary dark:bg-secondary;
  border-radius: 2px;
  transform: translateY(6px);
  transition: all 0.3s ease-in-out;
}

/* Open state - transform to X */
.hamburger-open .hamburger-line {
  background-color: transparent;
}

.hamburger-open .hamburger-line::before {
  transform: translateY(0) rotate(45deg);
}

.hamburger-open .hamburger-line::after {
  transform: translateY(0) rotate(-45deg);
}
</style>
